<body>
  <div class="grid-overlay">
    <app-page-header></app-page-header>

    <div class="reports-data">
      <div class="page-heading">
        <div>
          <h1>{{ 'onboardingUsersRoles.header.title' | translate }}</h1>
          <p>{{ 'onboardingUsersRoles.header.subtitle' | translate }}</p>
        </div>
      </div>

      <div class="rbac-tabs">
        <button type="button" [class.active]="activeTab === 'users'" (click)="setTab('users')">
          {{ 'onboardingUsersRoles.tabs.users' | translate }}
        </button>
        <button type="button" [class.active]="activeTab === 'roles'" (click)="setTab('roles')">
          {{ 'onboardingUsersRoles.tabs.roles' | translate }}
        </button>
      </div>

      @if (activeTab === 'users') {
        <section>
          <div class="hint">
            {{ 'onboardingUsersRoles.users.hint' | translate }}
          </div>
          <mat-accordion>
            <mat-expansion-panel [expanded]="isOpenSearchPanel" (opened)="openSearchPanel(true)" [hideToggle]="true">
              <mat-expansion-panel-header>
                <button class="btn-icon btn" [title]="'onboardingUsersRoles.filters.searchUsersTitle' | translate" type="button">
                  <i class="material-icons">search</i>
                </button>
              </mat-expansion-panel-header>
              <form>
                <fieldset class="fieldset">
                  <div class="fild_search">
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'onboardingUsersRoles.filters.name' | translate }}</mat-label>
                      <input matInput name="name_user" [(ngModel)]="filter.name_user" maxlength="120">
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'onboardingUsersRoles.filters.lastName' | translate }}</mat-label>
                      <input matInput name="lastName_user" [(ngModel)]="filter.lastName_user" maxlength="120">
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-label>{{ 'onboardingUsersRoles.filters.email' | translate }}</mat-label>
                      <input matInput name="email_user" [(ngModel)]="filter.email_user" maxlength="120">
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>{{ 'onboardingUsersRoles.filters.status' | translate }}</mat-label>
                      <mat-select [(value)]="filter.status_user">
                        <mat-option [value]="undefined">{{ 'onboardingUsersRoles.filters.all' | translate }}</mat-option>
                        @for (status of statusOptions; track status) {
                          <mat-option [value]="status.value">
                            {{ status.labelKey | translate }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </fieldset>
                <div class="button_report_align">
                  <button mat-raised-button type="button" class="button_report light" (click)="reset()">
                    <mat-icon>refresh</mat-icon>
                  </button>
                  <button mat-raised-button type="button" class="button_report blue" (click)="search()">
                    <mat-icon>search</mat-icon>
                  </button>
                </div>
              </form>
            </mat-expansion-panel>
          </mat-accordion>
          <div class="table-toolbar">
            <div></div>
            @if (canCreateUsers()) {
              <button mat-raised-button color="primary" (click)="openInviteModal()">
                <mat-icon>person_add</mat-icon>
                {{ 'onboardingUsersRoles.buttons.inviteUser' | translate }}
              </button>
            }
          </div>
          @if (!canListUsers()) {
            <div class="hint">
              {{ 'onboardingUsersRoles.messages.noPermissionListUsers' | translate }}
            </div>
          }
          @if (canListUsers()) {
            <mat-table [dataSource]="dataSource" class="rbac-table">
              <ng-container matColumnDef="user">
                <mat-header-cell *matHeaderCellDef>{{ 'onboardingUsersRoles.usersTable.user' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row" [attr.data-label]="'onboardingUsersRoles.usersTable.user' | translate">
                  {{ row.name_user }} {{ row.lastName_user }}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="email_user">
                <mat-header-cell *matHeaderCellDef>{{ 'onboardingUsersRoles.usersTable.email' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row" [attr.data-label]="'onboardingUsersRoles.usersTable.email' | translate">{{ row.email_user }}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="role">
                <mat-header-cell *matHeaderCellDef>{{ 'onboardingUsersRoles.usersTable.role' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row" [attr.data-label]="'onboardingUsersRoles.usersTable.role' | translate">
                  <div class="role-badges" [matTooltip]="getUserRolesTooltip(row)" [matTooltipDisabled]="getUserRoles(row).length <= 3">
                    @if (getUserRoles(row).length > 0) {
                      @for (role of getVisibleUserRoles(row); track role) {
                        <span class="badge" [ngClass]="getRoleClass(role)">
                          {{ role }}
                        </span>
                      }
                      @if (getUserRoles(row).length > 3) {
                        <span class="badge more">
                          +{{ getUserRoles(row).length - 3 }}
                        </span>
                      }
                    } @else {
                      <span class="badge custom">{{ 'onboardingUsersRoles.usersTable.noRole' | translate }}</span>
                    }
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="status_user">
                <mat-header-cell *matHeaderCellDef>{{ 'onboardingUsersRoles.usersTable.status' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row" [attr.data-label]="'onboardingUsersRoles.usersTable.status' | translate">
                  <span
                    class="status-pill"
                    [class.inactive]="row.status_user !== 1">
                    {{ getStatusLabel(row.status_user) }}
                  </span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef>{{ 'onboardingUsersRoles.usersTable.actions' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row" [attr.data-label]="'onboardingUsersRoles.usersTable.actions' | translate">
                  @if (canSeeUserActions(row)) {
                    <button mat-icon-button [matMenuTriggerFor]="userMenu" (click)="$event.stopPropagation()">
                      <mat-icon class="text-muted">more_vert</mat-icon>
                    </button>
                  }
                  <mat-menu #userMenu="matMenu">
                    @if (row.status_user === 1 && canUpdateUsers()) {
                      <button mat-menu-item (click)="updateUser(row)" class="menu_report">
                        <mat-icon>edit</mat-icon>
                        {{ 'onboardingUsersRoles.actions.edit' | translate }}
                      </button>
                    }
                    @if (row.status_user !== 1 && canUpdateUsers()) {
                      <button mat-menu-item (click)="reactivateUser(row)" class="menu_report">
                        <mat-icon>check_circle</mat-icon>
                        {{ 'onboardingUsersRoles.actions.reactivate' | translate }}
                      </button>
                    }
                    @if (row.status_user === 1 && canDeleteUsers()) {
                      <button mat-menu-item (click)="deactivateUser(row)" class="menu_report">
                        <mat-icon>block</mat-icon>
                        {{ 'onboardingUsersRoles.actions.deactivate' | translate }}
                      </button>
                    }
                    @if (row.status_user === 1 && canCreateUsers()) {
                      <button mat-menu-item (click)="resendInvitation(row)" class="menu_report">
                        <mat-icon>send</mat-icon>
                        {{ 'onboardingUsersRoles.actions.resendInvitation' | translate }}
                      </button>
                    }
                  </mat-menu>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
          }
          @if (canListUsers()) {
            <mat-paginator
              showFirstLastButtons
              [length]="tableService.pager.totalEntities"
              [pageIndex]="tableService.pager.pageIndex"
              [pageSize]="tableService.pager.pageSize"
              [pageSizeOptions]="[10, 20, 50, 100]"
              (page)="list($event)">
            </mat-paginator>
          }
        </section>
      }

      @if (activeTab === 'roles') {
        <section>
          <div class="hint">
            {{ 'onboardingUsersRoles.roles.hint' | translate }}
          </div>
          <div class="table-toolbar">
            <mat-form-field appearance="fill" class="role-search">
              <mat-label>{{ 'onboardingUsersRoles.filters.searchRole' | translate }}</mat-label>
              <input matInput (input)="searchRoles($event.target['value'])">
            </mat-form-field>
            <div class="toolbar-actions">
              <button mat-raised-button type="button" class="button_report light refresh-role-btn" (click)="refreshRoles()">
                <mat-icon>refresh</mat-icon>
              </button>
              @if (canCreateRoles()) {
                <button mat-raised-button color="primary" class="create-role-btn" (click)="createRole()">
                  <mat-icon>add</mat-icon>
                  {{ 'onboardingUsersRoles.buttons.createCustomRole' | translate }}
                </button>
              }
            </div>
          </div>
          <mat-table [dataSource]="rolesDataSource" class="rbac-table">
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef>{{ 'onboardingUsersRoles.rolesTable.name' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row" [attr.data-label]="'onboardingUsersRoles.rolesTable.name' | translate">
                <strong>{{ row.name }}</strong>
                @if (row.type === 'system') {
                  <span class="badge system">{{ 'onboardingUsersRoles.rolesTable.system' | translate }}</span>
                }
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="description">
              <mat-header-cell *matHeaderCellDef>{{ 'onboardingUsersRoles.rolesTable.description' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row" [attr.data-label]="'onboardingUsersRoles.rolesTable.description' | translate">{{ row.description }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="permissionCount">
              <mat-header-cell *matHeaderCellDef>{{ 'onboardingUsersRoles.rolesTable.assignedPermissions' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row" [attr.data-label]="'onboardingUsersRoles.rolesTable.permissions' | translate">
                {{ 'onboardingUsersRoles.rolesTable.permissionCount' | translate:{ count: row.permissionCount } }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="userCount">
              <mat-header-cell *matHeaderCellDef>{{ 'onboardingUsersRoles.rolesTable.users' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row" [attr.data-label]="'onboardingUsersRoles.rolesTable.users' | translate">{{ row.userCount }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef>{{ 'onboardingUsersRoles.rolesTable.actions' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row" [attr.data-label]="'onboardingUsersRoles.rolesTable.actions' | translate">
                @if (canSeeRoleActions(row)) {
                  <button mat-icon-button [matMenuTriggerFor]="roleMenu" (click)="$event.stopPropagation()">
                    <mat-icon class="text-muted">more_vert</mat-icon>
                  </button>
                }
                <mat-menu #roleMenu="matMenu">
                  @if (row.type === 'system') {
                    <button mat-menu-item (click)="viewRole(row)" class="menu_report">
                      <mat-icon>visibility</mat-icon>
                      {{ 'onboardingUsersRoles.actions.view' | translate }}
                    </button>
                  }
                  @if (row.type === 'custom' && canUpdateRoles()) {
                    <button mat-menu-item (click)="editRole(row)" class="menu_report">
                      <mat-icon>edit</mat-icon>
                      {{ 'onboardingUsersRoles.actions.edit' | translate }}
                    </button>
                  }
                  @if (row.type === 'custom' && canDeleteRoles()) {
                    <button mat-menu-item (click)="deleteRole(row)" class="menu_report">
                      <mat-icon>delete</mat-icon>
                      {{ 'onboardingUsersRoles.actions.delete' | translate }}
                    </button>
                  }
                </mat-menu>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="rolesDisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: rolesDisplayedColumns;"></mat-row>
          </mat-table>
        </section>
      }
    </div>

    <div class="options-buttons">
      <button class="back-btn" (click)="goBack()">{{ 'onboardingUsersRoles.buttons.back' | translate }}</button>
    </div>
  </div>

  <ng-template #inviteUserDialog>
      <div class="modal-header" mat-dialog-title>
        <h2>{{ 'onboardingUsersRoles.inviteModal.title' | translate }}</h2>
        <button mat-icon-button type="button" (click)="closeInviteModal()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form [formGroup]="inviteForm" (ngSubmit)="sendInvitation()">
        <mat-dialog-content class="invite-dialog-body">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>{{ 'onboardingUsersRoles.inviteModal.name' | translate }}</mat-label>
          <input matInput formControlName="name" maxlength="120">
          @if (inviteForm.get('name')?.hasError('required')) {
            <mat-error>{{ 'onboardingUsersRoles.inviteModal.nameRequired' | translate }}</mat-error>
          }
          @if (inviteForm.get('name')?.hasError('minlength')) {
            <mat-error>{{ 'onboardingUsersRoles.inviteModal.minLength' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>{{ 'onboardingUsersRoles.inviteModal.lastName' | translate }}</mat-label>
          <input matInput formControlName="lastName" maxlength="120">
          @if (inviteForm.get('lastName')?.hasError('required')) {
            <mat-error>{{ 'onboardingUsersRoles.inviteModal.lastNameRequired' | translate }}</mat-error>
          }
          @if (inviteForm.get('lastName')?.hasError('minlength')) {
            <mat-error>{{ 'onboardingUsersRoles.inviteModal.minLength' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>{{ 'onboardingUsersRoles.inviteModal.email' | translate }}</mat-label>
          <input matInput type="email" formControlName="email" maxlength="120">
          @if (inviteForm.get('email')?.hasError('required')) {
            <mat-error>{{ 'onboardingUsersRoles.inviteModal.emailRequired' | translate }}</mat-error>
          }
          @if (inviteForm.get('email')?.hasError('email')) {
            <mat-error>{{ 'onboardingUsersRoles.inviteModal.emailInvalid' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>{{ 'onboardingUsersRoles.inviteModal.password' | translate }}</mat-label>
          <input matInput [type]="hideInvitePassword ? 'password' : 'text'" formControlName="password" maxlength="120">
          <button mat-icon-button matSuffix (click)="hideInvitePassword = !hideInvitePassword" type="button">
            <mat-icon>{{ hideInvitePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (inviteForm.get('password')?.hasError('required')) {
            <mat-error>{{ 'onboardingUsersRoles.inviteModal.passwordRequired' | translate }}</mat-error>
          }
          @if (inviteForm.get('password')?.hasError('passwordStrength')) {
            <mat-error>{{ 'onboardingUsersRoles.inviteModal.passwordInvalid' | translate }}</mat-error>
          }
        </mat-form-field>

        <div class="password-requirements">
          <p class="requirements-title">{{ 'onboardingUsersRoles.passwordRequirements.title' | translate }}</p>
          <ul class="requirements-list">
            <li [class.valid]="getInvitePasswordErrors() === null || getInvitePasswordErrors()?.hasMinLength"
              [class.invalid]="getInvitePasswordErrors()?.hasMinLength === false">
              <mat-icon>{{ (getInvitePasswordErrors() === null || getInvitePasswordErrors()?.hasMinLength) ? 'check_circle' : 'cancel' }}</mat-icon>
              {{ 'onboardingUsersRoles.passwordRequirements.minLength' | translate }}
            </li>
            <li [class.valid]="getInvitePasswordErrors() === null || getInvitePasswordErrors()?.hasUpperCase"
              [class.invalid]="getInvitePasswordErrors()?.hasUpperCase === false">
              <mat-icon>{{ (getInvitePasswordErrors() === null || getInvitePasswordErrors()?.hasUpperCase) ? 'check_circle' : 'cancel' }}</mat-icon>
              {{ 'onboardingUsersRoles.passwordRequirements.uppercase' | translate }}
            </li>
            <li [class.valid]="getInvitePasswordErrors() === null || getInvitePasswordErrors()?.hasLowerCase"
              [class.invalid]="getInvitePasswordErrors()?.hasLowerCase === false">
              <mat-icon>{{ (getInvitePasswordErrors() === null || getInvitePasswordErrors()?.hasLowerCase) ? 'check_circle' : 'cancel' }}</mat-icon>
              {{ 'onboardingUsersRoles.passwordRequirements.lowercase' | translate }}
            </li>
            <li [class.valid]="getInvitePasswordErrors() === null || getInvitePasswordErrors()?.hasNumber"
              [class.invalid]="getInvitePasswordErrors()?.hasNumber === false">
              <mat-icon>{{ (getInvitePasswordErrors() === null || getInvitePasswordErrors()?.hasNumber) ? 'check_circle' : 'cancel' }}</mat-icon>
              {{ 'onboardingUsersRoles.passwordRequirements.number' | translate }}
            </li>
            <li [class.valid]="getInvitePasswordErrors() === null || getInvitePasswordErrors()?.hasSpecialChar"
              [class.invalid]="getInvitePasswordErrors()?.hasSpecialChar === false">
              <mat-icon>{{ (getInvitePasswordErrors() === null || getInvitePasswordErrors()?.hasSpecialChar) ? 'check_circle' : 'cancel' }}</mat-icon>
              {{ 'onboardingUsersRoles.passwordRequirements.special' | translate }}
            </li>
          </ul>
          <button type="button" mat-raised-button color="primary" (click)="generateInvitePassword()" class="generate-password-btn">
            <mat-icon>vpn_key</mat-icon>
            {{ 'onboardingUsersRoles.buttons.generatePassword' | translate }}
          </button>
        </div>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>{{ 'onboardingUsersRoles.inviteModal.assignRole' | translate }}</mat-label>
          <mat-select formControlName="roleId">
            @for (role of roles; track role) {
              <mat-option [value]="role.id">
                {{ role.name }} @if (role.type === 'system') {
                <span>({{ 'onboardingUsersRoles.rolesTable.system' | translate }})</span>
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      </mat-dialog-content>

      <mat-dialog-actions class="modal-actions">
        <button mat-raised-button type="button" (click)="closeInviteModal()">{{ 'onboardingUsersRoles.buttons.cancel' | translate }}</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="inviteForm.invalid">
          {{ 'onboardingUsersRoles.buttons.sendInvitation' | translate }}
        </button>
      </mat-dialog-actions>
    </form>
  </ng-template>
</body>
